import { render, staticRenderFns } from "./AdvCartDeliveryInfo.vue?vue&type=template&id=310580cc"
import script from "./AdvCartDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./AdvCartDeliveryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports